var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"autoInsertSpaceInButton":false}},[_c('div',{staticClass:"page-wrapper"},[_c('router-view'),_c('SuccessModal'),_c('Loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }